// import Pagination from "@mui/material/Pagination";

// const PaginationComp = ({ setPage, page, totalPage,message }) => {
//   const pageNumber = (e, p) => {
//     setPage(p);
//   };
//   return (
//     <>
//       <div className="row my-2 align-items-center justify-content-between">
//         <div className="col-6">
//           <div style={{textAlign: "left"}}>{message}</div>
//         </div>
//         <div className="col-6 d-flex justify-content-end">
//           <Pagination
//             count={totalPage}
//             page={page}
//             defaultPage={1}
//             size="large"
//             color="primary"
//             onChange={pageNumber}
//           />
//         </div>
//       </div>
//     </>
//   );
// };

// export default PaginationComp;


// import { Button } from "@mui/material";

// const PaginationComp = ({ setPage, page, totalPage, message }) => {
//   const handlePrevious = () => {
//     if (page > 1) setPage(page - 1);
//   };

//   const handleNext = () => {
//     if (page < totalPage) setPage(page + 1);
//   };

//   return (
//     <div
//       className="pagination-container"
//       style={{
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         flexWrap: 'wrap',
//         padding: '10px 20px',
//         background: '#fff',
//         borderTop: '1px solid #e0e0e0',
//         position: 'sticky',
//         bottom: 0,
//         zIndex: 10,
//         marginTop: '15px'
//       }}
//     >
//       <div
//         style={{
//           flex: '1',
//           textAlign: 'left',
//           fontSize: '14px',
//           minWidth: '200px',
//           marginBottom: '10px',
//         }}
//       >
//         {message}
//       </div>
//       <div
//         style={{
//           display: 'flex',
//           gap: '10px',
//           flexShrink: 0,
//           justifyContent: 'flex-end',
//         }}
//       >
//         <Button
//           onClick={handlePrevious}
//           disabled={page <= 1}
//           variant="outlined"
//         >
//           Previous
//         </Button>
//         <Button
//           onClick={handleNext}
//           disabled={page >= totalPage}
//           variant="contained"
//         >
//           Next
//         </Button>
//       </div>
//     </div>
//   );
// };

// export default PaginationComp;


import { Button } from "@mui/material";

const PaginationComp = ({ setPage, page, totalPage, message, disabled }) => {
  const handlePrevious = () => {
    if (page > 1) setPage(page - 1);
  };

  const handleNext = () => {
    if (page < totalPage) setPage(page + 1);
  };

  return (
    <div
      className="pagination-container"
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        padding: '10px 20px',
        background: '#fff',
        borderTop: '1px solid #e0e0e0',
        position: 'sticky',
        bottom: 0,
        zIndex: 10,
        marginTop: '15px'
      }}
    >
      <div
        style={{
          flex: '1',
          textAlign: 'left',
          fontSize: '14px',
          minWidth: '200px',
          marginBottom: '10px',
        }}
      >
        {!disabled && message}
      </div>
      <div
        style={{
          display: 'flex',
          gap: '10px',
          flexShrink: 0,
          justifyContent: 'flex-end',
        }}
      >
        <Button
          onClick={handlePrevious}
          disabled={disabled || page <= 1}
          variant="outlined"
        >
          Previous
        </Button>
        <Button
          onClick={handleNext}
          disabled={disabled || page >= totalPage}
          variant="contained"
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export default PaginationComp;
